export default "__VITE_ASSET__DtLaz6UE__"